import { useEffect, useState } from 'react';
import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../constants/ClientUrls';
import styles from './style.module.css';
import { Markup } from 'interweave';
import { HelmetComponent } from '../../components/Helmet';
import { api } from '../../server/api';
import { useAuth } from '../../hooks/useAuth';
import { List, ListItem } from '../../components/List';
import Modal from 'react-responsive-modal';
import OnboardingSection from './components/OnboardingSection';
import { ButtonBack } from '../../components/ButtonBack';

export function Infos() {
  const { client, player } = useAuth();
  const [itemActive, setItemActive] = useState(1);
  const [termsContent, setTermsContent] = useState<string>();
  const [termsContentSegmentation, setTermsContentSegmentation] =
    useState<string>();
  const [faqHeaderMessage, setFaqHeaderMessage] = useState<
    string | undefined
  >();
  const [titleHeadFaqMessage, setTitleHeadFaqMessage] = useState<
    string | undefined
  >();
  const [faqQuestions, setFaqQuestions] = useState<Array<object>>();
  const [isFaqHeader, setIsFaqHeader] = useState<boolean>();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [isActiveSegmentationFaq, setIsActiveSegmentationFaq] =
    useState<boolean>(false);
  const [isActiveSegmentationTerms, setIsActiveSegmentationTerms] =
    useState<boolean>(false);
  const [howItWorksContent, setHowItWorksContent] = useState<
    Array<{ htmlString?: string; termsImage?: string }>
  >([]);

  useEffect(() => {
    getClientFaq();
  }, []);

  const getClientTerms = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getClientTerms',
        userType: 'player',
        clientId: client && client.id,
      };

      const responseClientTerms = await api.post('/search', parameters);

      const { data } = responseClientTerms;
      if (data.success) {
        setTermsContent(data.data.htmlString ? data.data.htmlString : '');
        setIsActiveSegmentationTerms(eval(data.data.isActiveSegmentationTerms));
        setTermsContentSegmentation(data.data.htmlStringSegmentation);
      }
    } catch (error) {
      console.log('error getClientTerms-->', error);
    }
  };

  const getClientFaq = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getText',
        userType: 'player',
        clientId: client && client.id,
      };

      const responseClientTerms = await api.post('/search', parameters);

      const { data } = responseClientTerms;
      if (data.success) {
        setFaqQuestions(data.data.texts.faq.questions);
        setIsFaqHeader(
          data.data.texts.faq.headerFaq.confirmHeaderFaq === 'true'
            ? true
            : false
        );
        setFaqHeaderMessage(data.data.texts.faq.headerFaq.messageFaq);
        setTitleHeadFaqMessage(data.data.texts.faq.headerFaq.titleFaq);
        setIsActiveSegmentationFaq(
          eval(data.data.texts.faq.headerFaq.isActiveSegmentationFaq)
        );
        if (
          data.data.texts.howItWorks &&
          data.data.texts.howItWorks.length > 0
        ) {
          setHowItWorksContent(data.data.texts.howItWorks);
        }
      }
    } catch (error) {
      console.log('error getClientFaq-->', error);
    }
  };

  const renderFaq = () => {
    return (
      <>
        <div className="my-3">
          {isFaqHeader && (
            <>
              <p className="text-center fw-semibold fs-3">
                {titleHeadFaqMessage}
              </p>
              <p className="text-center">{faqHeaderMessage}</p>
            </>
          )}
          {isActiveSegmentationFaq && (
            <List>
              {faqQuestions &&
                faqQuestions.map((question: any, index) => (
                  <>
                    {player &&
                      question.segmentation &&
                      question.segmentation === player.regional && (
                        <ListItem
                          icon="help_outline"
                          key={index}
                          content={question.question}
                          expansible={true}
                          contentExpansible={
                            <Markup content={question.answer} />
                          }
                        />
                      )}
                  </>
                ))}
            </List>
          )}
          {isActiveSegmentationFaq && (
            <List>
              {faqQuestions &&
                faqQuestions.map((question: any, index) => (
                  <>
                    {player && question.segmentation === '' && (
                      <ListItem
                        icon="help_outline"
                        key={index}
                        content={question.question}
                        expansible={true}
                        contentExpansible={<Markup content={question.answer} />}
                      />
                    )}
                  </>
                ))}
            </List>
          )}
          {!isActiveSegmentationFaq && (
            <List>
              {faqQuestions &&
                faqQuestions.map((question: any, index) => (
                  <ListItem
                    icon="help_outline"
                    key={index}
                    content={question.question}
                    expansible={true}
                    contentExpansible={<Markup content={question.answer} />}
                  />
                ))}
            </List>
          )}
        </div>
      </>
    );
  };

  const renderHowItWorks = () => {
    const adminContent =
      howItWorksContent.length > 0 ? (
        <>
          {howItWorksContent.map((item, index) => (
            <div key={index} className="my-3">
              {item.termsImage && (
                <div className="text-center mb-3">
                  <img src={item.termsImage} style={{ maxWidth: '100%' }} />
                </div>
              )}
              {item.htmlString && <Markup content={item.htmlString} />}
            </div>
          ))}
        </>
      ) : undefined;

    return <OnboardingSection topContent={adminContent} />;
  };

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Informações'}
      />

      <div className="row">
        <div className="my-3">
          <ButtonBack title="Informações" />
        </div>
      </div>
      <div className="my-3">
        {/* Menu de opções */}
        <div className="row">
          <div className="col-sm-12 col-md-3">
            <div
              className={`p-3 mb-3 ${styles.tabItem} ${
                itemActive === 1 ? styles.active : ''
              }`}
              onClick={() => {
                setItemActive(1);
              }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined fs-5 me-3 color-text">
                  contact_support
                </i>
                <span>Como funciona</span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div
              className={`p-3 mb-3 ${styles.tabItem} ${
                itemActive === 2 ? styles.active : ''
              }`}
              onClick={() => {
                setItemActive(2);
                getClientFaq();
              }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined fs-5 me-3 color-text">
                  sms_failed
                </i>
                <span>Faq</span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div
              className={`p-3 mb-3 ${styles.tabItem} ${
                itemActive === 3 ? styles.active : ''
              }`}
              onClick={() => {
                setItemActive(3);
                getClientTerms();
              }}
            >
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined fs-5 me-3 color-text">
                  assignment
                </i>
                <span>Termos</span>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className={`p-3 mb-3 ${styles.tabItem}`} onClick={toggleModal}>
              <div className="d-flex align-items-center justify-content-center">
                <i className="material-icons-outlined me-3 fs-5 color-text">
                  inventory
                </i>
                <span>Privacidade</span>
              </div>
            </div>
          </div>
        </div>
        {/* fim Menu de opções */}
      </div>
      <div className="row">
        <div className="col-sm-12">
          {/* Renderização do conteúdo */}
          {itemActive === 1 && renderHowItWorks()}
          {itemActive === 2 && renderFaq()}
          {itemActive === 3 && (
            <div className="my-3">
              <Markup
                content={
                  isActiveSegmentationTerms && player.regional === 'sim'
                    ? termsContentSegmentation
                    : termsContent
                }
              />
            </div>
          )}
          <Modal open={modalIsOpen} onClose={toggleModal}>
            <div className="contents-modal">
              <h1 className="title-modal">Documentos importantes</h1>
              <p className="subtitle-modal">
                Acesse abaixo alguns documentos importantes da plataforma.
              </p>
              <List>
                <a
                  href={
                    client?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL
                      ? 'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPoliticaPrivacidade_GanheMaisCorretor_CORRETOR.docx.pdf?alt=media&token=0d3cc869-b87e-4c60-b611-b4313265034d'
                      : 'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPOLI%CC%81TICA%20DE%20PRIVACIDADE%20LGPD%20COMPLIANCE%202026.pdf?alt=media&token=f6339049-9c75-4ac2-8417-a70c9d75be94'
                  }
                  target="_blank"
                >
                  <ListItem icon="link" content="Políticas de privacidade" />
                </a>
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FComunicação Violação de Dados_OQ DIGITAL.docx (1).pdf?alt=media&token=49390915-d267-4251-8dc8-473aaee1fda9"
                  target="_blank"
                >
                  <ListItem
                    icon="link"
                    content="Comunicação violação de dados"
                  />
                </a>
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FBCR%20%20OQ%20DIGITAL.docx.pdf?alt=media&token=4ea9ee8b-1753-4f97-ae4c-13780464d76d"
                  target="_blank"
                >
                  <ListItem icon="link" content="BCR OQ Digital" />
                </a>
              </List>
            </div>
          </Modal>
          {/* fim Renderização do conteúdo */}
        </div>
      </div>
    </>
  );
}
